import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isExpanded: false,
};

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setExpanded: (state, action) => {
      state.isExpanded = action.payload;
    },
  },
});

export const { setExpanded } = sidebarSlice.actions;

export const sidebarReducer = sidebarSlice.reducer;
export default sidebarSlice.reducer;
